function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { TimeType } from './Time';
export var RangeTime = function () {
  function RangeTime(options) {
    _classCallCheck(this, RangeTime);

    this.left = options.left;
    this.right = options.right;
  }

  _createClass(RangeTime, [{
    key: "repaint",
    value: function repaint() {
      this.left.repaintTime();
      this.right.repaintTime();
    }
  }, {
    key: "compare",
    value: function compare(v, type, part) {
      var isLeft = part === this.left.part;
      var leftPanel = this.left;
      var rightPanel = this.right;

      switch (type) {
        case TimeType.HOUR:
          return this.hourDisabled(v, leftPanel, rightPanel, isLeft);

        case TimeType.MINUTE:
          return this.minuteDisabled(v, leftPanel, rightPanel, isLeft);

        case TimeType.SECOND:
          return this.secondDisabled(v, leftPanel, rightPanel, isLeft);
      }
    }
  }, {
    key: "hourDisabled",
    value: function hourDisabled(v, l, r, isLeft) {
      var showMinute = l.showMinute,
          showSecond = l.showSecond;

      if (l.hour === null || r.hour === null) {
        return false;
      }

      if (isLeft) {
        if (showMinute && l.minute && r.minute && l.minute > r.minute || showMinute && l.minute === r.minute && showSecond && l.second && r.second && l.second > r.second || !showMinute && showSecond && l.second && r.second && l.second > r.second) {
          return v >= r.hour;
        }

        return v > r.hour;
      }

      if (showMinute && l.minute && r.minute && l.minute > r.minute || showMinute && l.minute === r.minute && showSecond && l.second && r.second && l.second > r.second || !showMinute && showSecond && l.second && r.second && l.second > r.second) {
        return v <= l.hour;
      }

      return v < l.hour;
    }
  }, {
    key: "minuteDisabled",
    value: function minuteDisabled(v, l, r, isLeft) {
      var showHour = l.showHour,
          showSecond = l.showSecond;

      if (showHour && l.hour !== r.hour || r.minute === null || l.minute === null) {
        return false;
      }

      if (isLeft) {
        if (showSecond && l.second && r.second && l.second > r.second) {
          return v >= r.minute;
        }

        return v > r.minute;
      }

      if (showSecond && l.second && r.second && l.second > r.second) {
        return v <= l.minute;
      }

      return v < l.minute;
    }
  }, {
    key: "secondDisabled",
    value: function secondDisabled(v, l, r, isLeft) {
      var showHour = l.showHour,
          showMinute = l.showMinute;

      if (r.second === null || l.second === null || showHour && l.hour !== r.hour || showMinute && l.minute !== r.minute) {
        return false;
      }

      if (isLeft) {
        return v > r.second;
      }

      return v < l.second;
    }
  }]);

  return RangeTime;
}();